export const defaults = {
    itemsPerPage: 20,
    maxPages: 10,
    maxFileSize: 5000000,

    saveSuccess: "მონაცემები წარმატებით შეინახა!",
    passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{6,}$/,
    idRegex: /^[\w-]{6,11}$/,
    legalIdRegex: /^[\w-]{6,20}$/,
}